import { MesfModal } from "@dexteel/mesf-core";
import { TextField } from "@mui/material";

type Props = {
	open: boolean;
	onClose: () => void;
	notes: string;
	partNumber: string;
};

export const ViewNotesModal = ({ open, onClose, notes, partNumber }: Props) => {
	return (
		<MesfModal
			id="modal-view-notes"
			title={`NOTES - ${partNumber}`}
			open={open}
			handleClose={onClose}
			maxWidth="sm"
		>
			<MesfModal.Content style={{ padding: "20px 30px" }}>
				<TextField
					label="Notes"
					variant="outlined"
					value={notes}
					fullWidth
					multiline
					rows={4}
					disabled
					InputProps={{
						readOnly: true,
					}}
				/>
			</MesfModal.Content>
		</MesfModal>
	);
};
